export default class Locale_MoveAllAllocationsDialog { 
	FailedMovingAllocations: string = "Failed moving allocations";
	DialogTitle: string = "Move all allocations to";
	SubTextSuccess: string = "Succesfully moved all allocations";
	SubText: string = "Select a resource to move the allocations to.";
}